<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container lg">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">裁判所を指定</span>
        </div>

        <form @submit.prevent="group1.search">
          <div class="popup-content">
            <p class="txt mb20">裁判所を指定してください。</p>
            <div class="formparts function suggest">
              <input v-model="group1.search_text" type="text" placeholder="キーワード">
              <div @click="group1.search" class="button" role="button"><FontawesomeIcon icon="search" class="icn" /></div>
              <ul class="suggest-list">

                <li v-for="(item, index) in group1.list" :key="'court_list_' + index" role="option">
                  <input type="radio"
                    v-model="group1.court_name"
                    :value="item.value2"
                    @change="group1.onSelectedItemsChanged()" 
                    :id="'court_' + item.id">
                  <label :for="'court_' + item.id">{{ item.value2 }}</label>
                </li>
              </ul>
            </div>
            <div class="button mt32">
              <button type="button" class="btn" @click="group1.submit">決定</button>
            </div>      
          </div>
        </form>

      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import * as logicDocumentCourtList from '@/logic/document/DocumentCourtList.js'

export default defineComponent({
  props: {
    startLoading: {
      type: Boolean,
      required: true
    },
    saibansyoList: {
      type: Array,
      required: true
    }
  },
  setup (props, context) {

    const { group1, state } = logicDocumentCourtList.getGroup(props, context)

    const close = () => {
      context.emit('closeSearchDetailCourtList')
    }
   
    return {
      group1,
      state,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
.popup-content {
  .button .btn {
    width: 232px;
    margin-right: auto;
    margin-left: auto;
  }
  .suggest-list {
    input[type="radio"]:checked + label:after {
      opacity: 1;
    }
    label {
      position: relative;
      padding-left: 52px;
      &:before,&:after {
        content: '';
        position: absolute;
        top: 50%;
        transform: translate3d(0,-50%,0);
        border-radius: 50%;
      }
      &:before {
        left: 20px;
        width: 20px;
        height: 20px;
        background-color: $color-bg-form;
      }
      &:after {
        left: 24px;
        width: 12px;
        height: 12px;
        background-color: $color-link;
        opacity: 0;
      }
    }
  }
}
</style>
